import {createEntityAdapter, EntityState} from '@reduxjs/toolkit';

import {ChatMessage} from "../../models";

export const type = 'chats';

export interface ChatsState extends EntityState<ChatMessage, number> {
    isFetching: boolean;
    isSending: boolean;
    selectedId: number | null;
    errorMessage?: string;
    // Snapshot of the message ids known when the in-flight getAll began. Only
    // these are prune candidates on fulfilment — anything added mid-fetch (an
    // optimistic send or an FCM push) arrived after the server built its
    // snapshot and must survive the prune. Transient; cleared on settle.
    pendingFetchIds?: number[];
}

export const adapter = createEntityAdapter<ChatMessage>({
});

export const initialState: ChatsState = adapter.getInitialState({
    isFetching: false,
    isSending: false,
    selectedId: null,
    errorMessage: undefined,
});
